import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-group-filter-details',
  templateUrl: './group-filter-details.component.html',
  styleUrls: ['./group-filter-details.component.scss'],
})
export class GroupFilterDetailsComponent  implements OnInit {

  breadcrumbList = [
    {
      label: 'Group filters',
      embedurl: true,
      url: '/baseapp/user-group'
    },
    {
      label: 'Filter details',
      embedurl: false,
      url: ''
    }
  ];

  groupDetailsObj;
  userGroupList = [];
  selectedGroupArr = [];
  updateUserGroupForm: UntypedFormGroup;
  userIp;
  page_min = 0;
  page_max = 5;
  hide1200: boolean = true;
  filterId: any;
  groupId: any;
  getGroupFilterApi: Subscription | undefined;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    private route: ActivatedRoute,
    public storage: Storage,
    public helperService: HelperService) { }

  ngOnInit() {
    const queryParams = this.route.snapshot.paramMap;
    this.filterId = queryParams.get('id');
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });

    this.getUserIp();
    this.getGroupDetails(this.filterId);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.helperService.closeLoader();
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.getGroupFilterApi) {
      this.getGroupFilterApi.unsubscribe();
    }
    this.helperService.closeLoader();
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }

  updateBreadcrumbUrl(): void {
    const breadcrumbUrl = '/baseapp/user-group/group-filters';
    const urlTree = this.router.createUrlTree([breadcrumbUrl, this.groupId]);
    this.breadcrumbList[0].url = urlTree.toString();
  }

  getGroupDetails(filterId) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id: filterId
      }
      this.getGroupFilterApi = this.backendService.PostAPICall('getGroupFilterById', payload, res.token).subscribe(
        (data) => {
          let res = data.data;
          this.groupId = res.group_id;
          this.updateBreadcrumbUrl();
          this.groupDetailsObj = res;
          this.helperService.closeLoader();
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  goToGroupFilterList() {
    this.router.navigate(['/baseapp/user-group/group-filters', this.groupId]);
  }

}
